export { default as anatomyV2IntroPNG } from '~/assets/images/anatomyV2/anatomy-v2-intro-preview.png'
export { default as anatomyV2IntroWEBP } from '~/assets/images/anatomyV2/anatomy-v2-intro-preview.webp'
export { ANATOMY_V2_ACCENT_COLOR as INTRO_ACCENT_COLOR } from '~/pages/anatomyV2/libs/constants'

export const LOADER_DURATION_MS = 3500
export const LOADER_TICK_MS = 100
